import * as React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
import { omit } from 'lodash';
const ControlPutAwayForm = React.memo((props) => (<Icon component={() => (
    // <svg
    //   focusable="false"
    //   width="1em"
    //   height="1em"
    //   fill="currentColor"
    //   viewBox="0 0 24 24"
    //   style={{ transform: `rotate(${props.rotate}deg)` }}
    // >
    //   <path d="M9.946 7.445a.5.5 0 0 1 .638-.057l.07.057 4.2 4.2a.5.5 0 0 1 .057.638l-.057.07-4.2 4.2a.5.5 0 0 1-.765-.638l.057-.07 3.847-3.846-3.847-3.846a.5.5 0 0 1-.057-.638l.057-.07Z" />
    // </svg>
    <svg focusable="false" width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24" style={{ transform: `rotate(${props.rotate}deg)` }}>
        <g>
          <path d="m9.545 12.466 4.4 4.354c.246.24.634.24.874-.005a.617.617 0 0 0-.005-.876l-3.96-3.919 3.92-3.965a.617.617 0 0 0-.006-.875.615.615 0 0 0-.874.005l-4.355 4.406c-.24.24-.24.635.006.875z" transform="rotate(180 12.18 12)"/>
        </g>
      </svg>)} {...omit(props, 'rotate')}/>));
export default ControlPutAwayForm;
